// reducers.js
import {
FETCH_LICENCE,
SET_LICENCE,
} from '../actions';

const initialState = {
    licenceData: null,
    isLoading: false,
    error: null,
};

const licenceReducer = (state = initialState, action) => {


    switch (action.type) {

        // case SET_LOADING:
        //     return {
        //         ...state,
        //         isLoading: action.payload,
        //     };
        //
        // case SET_ERROR:
        //     return {
        //         ...state,
        //         error: action.payload,
        //     };

        case FETCH_LICENCE:
            return {
                ...state,
            };

        case SET_LICENCE:
            return {
                ...state,
                licenceData: action.payload,
                isLoading: false,
            };

        default:
            return state;
    }
};

export default licenceReducer;
